import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export const useRegister = options =>
    useMutation({
        mutationFn: registration => axios.post("/api/register", registration).then(res => res.data),
        ...options
    });
